import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommFlower2Icon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M21.7717 8.92917C21.0382 6.72576 18.767 5.49905 16.5741 5.88282C16.2615 3.69196 14.3294 2 12 2C9.6706 2 7.73849 3.69196 7.42591 5.88282C5.23282 5.4992 2.96192 6.72553 2.22833 8.92917C1.49465 11.133 2.59383 13.4278 4.5986 14.3755C3.53204 16.3272 4.07626 18.8045 5.96075 20.1408C7.83099 21.467 10.4151 21.2295 12 19.6232C13.5846 21.2291 16.168 21.4676 18.0392 20.1408C19.9237 18.8045 20.4679 16.3272 19.4014 14.3755C21.4067 13.4276 22.5052 11.1326 21.7717 8.92917ZM18.3238 13.1587L17.9672 13.2718C17.4623 13.4319 17.2653 14.0267 17.5766 14.445L17.797 14.741C18.7875 16.0716 18.4842 17.9405 17.121 18.9072C15.7577 19.8738 13.8428 19.5778 12.8524 18.2473L12.632 17.9512C12.3199 17.532 11.6794 17.5329 11.368 17.9512L11.1476 18.2473C10.1572 19.5778 8.24228 19.8738 6.87907 18.9072C5.51583 17.9405 5.21251 16.0715 6.20298 14.741L6.42337 14.445C6.7354 14.0258 6.53657 13.4315 6.03278 13.2717L5.67622 13.1587C4.06997 12.6493 3.19208 10.9683 3.71415 9.40036C4.23399 7.83871 5.95204 6.97392 7.56486 7.48541L7.9215 7.59849C8.4254 7.75815 8.94404 7.39154 8.94404 6.87338V6.50742C8.94404 4.86278 10.315 3.52478 12 3.52478C13.685 3.52478 15.0559 4.86282 15.0559 6.50742V6.87338C15.0559 7.3915 15.5746 7.75819 16.0785 7.59849L16.4351 7.48537C18.0413 6.97606 19.7638 7.83227 20.2858 9.40036C20.8078 10.968 19.9303 12.6492 18.3238 13.1587Z"
            fill="#222"
          />
          <path
            d="M12.0007 8.91324C10.2778 8.91324 8.8761 10.2813 8.8761 11.9629C8.8761 13.6445 10.2778 15.0125 12.0007 15.0125C13.7236 15.0125 15.1253 13.6445 15.1253 11.9629C15.1253 10.2813 13.7237 8.91324 12.0007 8.91324ZM12.0007 13.4877C11.1393 13.4877 10.4384 12.8036 10.4384 11.9628C10.4384 11.1221 11.1393 10.438 12.0007 10.438C12.8622 10.438 13.563 11.1221 13.563 11.9628C13.563 12.8036 12.8622 13.4877 12.0007 13.4877Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
